export const BASE_URL = process.env.REACT_APP_BASE_URL
export const VERSION = "v2";
export const PROFILE_IMAGE_URL = "assets/profile_picture"